import React, { useState } from "react";
import TawkToWidget from "../ChatIntigration/TawkToWidget";
import { FiMessageCircle, FiPhone, FiX } from "react-icons/fi";
import { IoDocumentTextOutline } from "react-icons/io5";
import { LuBadgeHelp } from "react-icons/lu";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getWebsiteSettingData } from "../../Redux/action/MasterAction";
import { Modal } from "react-bootstrap";

const FeedbackForm = () => {



    const [contactModal, setContactModal] = useState(false);
    const dispatch = useDispatch();

    const [open, setOpen] = useState(false);
    const navigate = useNavigate();

    const { tutorAuthenticated } =
        useSelector((state) => state.tutor?.auth) || {};

    const { WebsiteSettingDataListApiData } =
        useSelector((state) => state?.MasterReducer);

    // tutor login → hide widget
    if (tutorAuthenticated) return null;

    const handleChatOpen = () => {
        if (window.Tawk_API) {
            window.Tawk_API.showWidget();
            window.Tawk_API.maximize();
        }
    };

    return (
        <>
            <style
                dangerouslySetInnerHTML={{
                    __html: `

.help-wrapper{
position:fixed;
top:50%;
right:0;
transform:translateY(-50%);
z-index:9999;
}

.help-btn{
background:#1f6feb;
color:#fff;
height:80px;
width:32px;
border-radius:12px 0 0 12px;
display:flex;
 
align-items:center;
justify-content:center;
cursor:pointer;
font-weight:600;
writing-mode:vertical-rl;
letter-spacing:1px;
 gap: 3px;
}
.help-icon{

color:#ffff;
border-radius:50%;
display:flex;
align-items:center;
justify-content:center;
}

.support-panel{
position:absolute;
right:100%;
margin-right:10px;
top:0;
width:260px;
background:#fff;
border-radius:12px;
box-shadow:0 12px 30px rgba(0,0,0,0.15);
padding:14px;
animation:slideIn .25s ease;
}

@keyframes slideIn{
from{opacity:0;transform:translateX(20px)}
to{opacity:1;transform:translateX(0)}
}

.item{
display:flex;
gap:12px;
padding:10px;
border-radius:8px;
cursor:pointer;
}

.item:hover{
background:#f3f6fb;
}

.title{
font-size:14px;
font-weight:600;
}

.desc{
font-size:12px;
color:#666;
}

.close-icon{
position:absolute;
top:10px;
right:10px;
cursor:pointer;
}

`
                }}
            />

            <div className="help-wrapper">

                {open && (
                    <div className="support-panel">

                        {/* <FiX
              className="close-icon"
              size={20}
              onClick={() => setOpen(false)}
            /> */}

                       {/* Student Manual */}
<div
  className="item"
  onClick={() => window.open("/pdf/student_manual.pdf", "_blank")}
>
  <IoDocumentTextOutline size={24} color="#1f6feb" />
  <div>
    <div className="title">Student Manual</div>
    <div className="desc">
      Student Guidelines
    </div>
  </div>
</div>

{/* Tutor Manual */}
<div
  className="item"
  onClick={() => window.open("/pdf/tutor_manual.pdf", "_blank")}
>
  <IoDocumentTextOutline size={24} color="#1f6feb" />
  <div>
    <div className="title">Tutor Manual</div>
    <div className="desc">
      Tutor Guidelines
    </div>
  </div>
</div>

                        <div
                            className="item"
                            onClick={() =>
                                window.open(
                                    "https://docs.google.com/forms/d/e/1FAIpQLSfNxx-fbPfRkTayReF3HQd_CkY5Hh_9ArMtXTMwy3VXK_j3VQ/viewform",
                                    "_blank"
                                )
                            }
                        >
                            <LuBadgeHelp size={24} color="#1f6feb" />
                            <div>
                                <div className="title">Feedback</div>
                                <div className="desc">
                                    Feedback Form
                                </div>
                            </div>
                        </div>

                        <div
                            className="item"
                            onClick={handleChatOpen}
                        >
                            <FiMessageCircle size={23} color="#1f6feb" />
                            <div>
                                <div className="title">Chat Support</div>
                                <div className="desc">
                                    Start live chat
                                </div>
                            </div>
                        </div>

                        <div
                            className="item"
                            onClick={() => {
                                dispatch(getWebsiteSettingData());
                                setOpen(false);
                                setContactModal(true);
                            }}
                        >
                            <FiPhone size={23} color="#1f6feb" />
                            <div>
                                <div className="title">Contact Us</div>
                                <div className="desc">
                                    Call or email support
                                </div>
                            </div>
                        </div>

                    </div>
                )}

                <div
                    className="help-btn"
                    onClick={() => setOpen(!open)}
                >
                    {open ? (
                        <FiX size={18} />
                    ) : (
                        <>
                            Help

                            <span className="help-icon">
                                <LuBadgeHelp size={14} />
                            </span>





                        </>
                    )}
                </div>

            </div>

            <Modal
                show={contactModal}
                onHide={() => setContactModal(false)}
                centered
                size="lg"
            >
                <Modal.Header closeButton>
                    <h5 className="modal-title">Contact Us</h5>
                </Modal.Header>

                <Modal.Body>

                    <div className="text-center">

                        <img
                            src="https://tse2.mm.bing.net/th?id=OIP.lpdwrxp78JIWMumGLRyyeAHaE7&pid=Api&P=0&h=380"
                            alt="contact"
                            className="img-fluid mb-3"
                            style={{ maxWidth: "350px" }}
                        />

                        <h5>Get Support</h5>

                        <p style={{ fontSize: 14 }}>
                            Facing any issues with the platform? We're here to help!
                            Contact our support team.
                        </p>

                        <div
                            className="d-flex justify-content-center"
                            style={{ gap: 15 }}
                        >

                            <a
                                href={`mailto:${ WebsiteSettingDataListApiData?.email }?subject=Support Request`}
                            >
                                <button className="btn btn-primary">
                                    Mail Us Now
                                </button>
                            </a>

                            <a
                                href={`tel:${ WebsiteSettingDataListApiData?.mobile }`}
                            >
                                <button className="btn btn-primary">
                                    Call Us Now
                                </button>
                            </a>

                        </div>

                    </div>

                </Modal.Body>
            </Modal>


            <TawkToWidget />
        </>
    );
};

export default FeedbackForm;